import React, { Component, Fragment } from "react";
import { Field, reduxForm } from "redux-form";
import validate from "./validate";
import renderField from "./renderField";
import renderDropdown from "./renderDropdown";
import Typography from "@material-ui/core/Typography";
import RenderProcessorOptions from "./renderProcessorOptions";
import RenderCountiesOptions from "./renderCountiesOptions";
import { connect } from "react-redux";
import { ActionCreators } from "../../actions";
import GoogleMaps from "../googleMapsDialogs";
import ListSubheader from "@material-ui/core/ListSubheader";
import PinDrop from "@material-ui/icons/PinDrop";

const numeric = value =>
  value && /[^0-9]/i.test(value) ? "Only numeric characters" : undefined;

class WizardFormFirstPage extends Component {


  handleRest = (reset) => {
    reset()
    this.props.resetMap();
  }
  renderLatLong = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <ListSubheader disableSticky={true} >
      <PinDrop />{` Lat: ${JSON.stringify(this.props.GoogleMapsReducer.Lat)}`}
      </ListSubheader>
      <ListSubheader   disableSticky={true} >
      <PinDrop /> {` Long: ${JSON.stringify(this.props.GoogleMapsReducer.Long)}`}
      </ListSubheader>
    </div>
  );

  renderCoordField = ({ input: { onChange } }) => {
    return (
      <div className="form-group">
        <ListSubheader disableSticky={true} component="div">
          Note: you may use a GPS unit or you can use the Google Maps Below,
          zoom and move the marker to your location then confirm coordinates in
          App Bar. When finished click the save in the left corner and your
          form will be updated with the coordinates.
        </ListSubheader>
        <div
          className="containter"
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            marginBottom: 15
          }}
        >
          <GoogleMaps getLatLong={value => onChange(value)} />
          <br />
          {this.props.GoogleMapsReducer.Lat && this.renderLatLong()}
        </div>
      </div>
    );
  };

  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;
    return (
      <Fragment>
        <Typography variant="title" color="inherit">
          Employee Information
        </Typography>
        <hr />

        <form onSubmit={handleSubmit}>
          <Field
            name="aasisId"
            type="text"
            component={renderField}
            label="Aasis ID"
            validate={[numeric]}
          />
          <Field
            name="processorTaxidermyId"
            type="text"
            component={renderDropdown}
            label="Processor & Taxidermy ID"
            optionsData={<RenderProcessorOptions />}
          />
          <Field name="utme" type="text" component={renderField} label="UTME" />
          <Field name="utmn" type="text" component={renderField} label="UTMN" />

          <Field name="googleCoordinates" component={this.renderCoordField} />

          <Field
            name="county"
            type="text"
            component={renderDropdown}
            label="County"
            optionsData={<RenderCountiesOptions />}
          />

          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <button
              className="btn btn-secondary"
              type="button"
              disabled={pristine || submitting}
              onClick={() => this.handleRest(reset) }
            >
              Reset
            </button>

            <button className="btn btn-success" type="submit">
              Next
            </button>
          </div>
        </form>
      </Fragment>
    );
  }
}

export default reduxForm({
  form: "wizard", // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate
})(
  connect(
    ({ GoogleMapsReducer }) => {
      return {
        GoogleMapsReducer
      };
    },
    ActionCreators
  )(WizardFormFirstPage)
);



// WEBPACK FOOTER //
// ./src/components/wizardSection/WizardFormFirstPage.jsx